module.exports = __webpack_public_path__ + "static/img/user_default_img.2f640d95.png";